/** A Foglalások áttekintése négy listája — mindegyik egy fül. */
export type OverviewList = 'confirmable' | 'arrivals' | 'guests' | 'departures';

/** Egy lista betöltési állapota. A hiba soha nem jelenhet meg üres listaként. */
export type ListLoadStatus = 'loading' | 'ready' | 'error';

export type ListLoadStatuses = Readonly<Record<OverviewList, ListLoadStatus>>;

export const INITIAL_LIST_LOAD_STATUSES: ListLoadStatuses = {
  confirmable: 'loading',
  arrivals: 'loading',
  guests: 'loading',
  departures: 'loading'
};

export const withListStatus = (statuses: ListLoadStatuses, list: OverviewList, status: ListLoadStatus): ListLoadStatuses => ({
  ...statuses,
  [list]: status
});

/** Mit mutasson egy fül táblázata. */
export type TableView = 'skeleton' | 'rows' | 'empty' | 'error';

export function tableViewFor(status: ListLoadStatus, rowCount: number): TableView {
  if (status === 'loading') {
    return 'skeleton';
  }
  if (status === 'error') {
    return 'error';
  }
  return rowCount > 0 ? 'rows' : 'empty';
}

/** A fül fejlécében látható jelzés. A 0 is látszik, halványabban, hogy ne tűnjön „még tölt”-nek. */
export type TabBadge =
  | { readonly kind: 'loading' }
  | { readonly kind: 'error' }
  | { readonly kind: 'count'; readonly value: number; readonly severity: 'info' | 'secondary' };

export function tabBadgeFor(status: ListLoadStatus, count: number): TabBadge {
  if (status === 'loading') {
    return { kind: 'loading' };
  }
  if (status === 'error') {
    return { kind: 'error' };
  }
  return { kind: 'count', value: count, severity: count > 0 ? 'info' : 'secondary' };
}

/** Ennyi helykitöltő sor látszik töltés közben. */
export const SKELETON_ROW_COUNT = 5;

export interface SkeletonRowPlaceholder {
  readonly skeletonIndex: number;
}

/** Hívásonként új, módosítható tömb: a p-table rendezéskor helyben rendezi a `value`-t. */
export const createSkeletonRows = (): SkeletonRowPlaceholder[] =>
  Array.from({ length: SKELETON_ROW_COUNT }, (_, skeletonIndex) => ({ skeletonIndex }));

/** Egy helykitöltő cella alakja, a valódi cella tartalmához igazítva. */
export type SkeletonColumn = 'guest' | 'flat' | 'icon' | 'text' | 'actions';
